'use strict';

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { App } from './App';
import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ReactDom from 'react-dom';
import { LogProvider } from "./Providers/LogProvider";
import { LogSearch } from "./Search"; // Enable React devtools

window.React = React;
var logProvider = new LogProvider(50);
OCA.Search.logreader = new LogSearch(logProvider);

function render(App, rootElement) {
  ReactDom.render(React.createElement(AppContainer, null, React.createElement(App, {
    logProvider: logProvider,
    inlineSettings: rootElement.dataset.inlineSettings === 'true'
  })), rootElement);
}

$(document).ready(function () {
  var rootElement = document.getElementById('logreader-root');
  render(App, rootElement);

  if (module.hot) {
    module.hot.accept('./App', function () {
      var _require = require('./App'),
          NextApp = _require.App;

      render(NextApp, rootElement);
    });
  }
});
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(logProvider, "logProvider", "/srv/http/owncloud/apps/logreader/js/index.js");
  reactHotLoader.register(render, "render", "/srv/http/owncloud/apps/logreader/js/index.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();